// Mock data for PodioSoins+ Healthcare Website - Realistic and Relevant

export const nurseInfo = {
  name: "Salwa Chraibi",
  title: "Infirmière spécialisée",
  specializations: ["Soins de plaies", "Soins de pieds"],
  experience: "10+ années d'expérience",
  location: "Longueuil, Québec",
  phone: "819-469-4419",
  email: "salwa.connexion@gmail.com",
  image: "https://images.unsplash.com/photo-1532938911079-1b06ac7ceec7?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2MzR8MHwxfHNlYXJjaHwyfHxoZWFsdGhjYXJlfGVufDB8fHx8MTc1NTE5MTExOHww&ixlib=rb-4.1.0&q=85"
};

export const services = [
  {
    id: 1,
    category: "wound-care",
    title: "Soins de plaies",
    description: "Prévention, traitement et suivi professionnel des plaies de tous types",
    image: "https://images.unsplash.com/photo-1609840533741-62c180d0be79?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzV8MHwxfHNlYXJjaHwxfHx3b3VuZCUyMGNhcmV8ZW58MHx8fHwxNzU1MTkxNjIxfDA&ixlib=rb-4.1.0&q=85",
    services: [
      "Évaluation et nettoyage des plaies",
      "Changement de pansements",
      "Retrait d'agrafes ou de suture",
      "Pansements spécialisés",
      "Prévention des infections",
      "Suivi et surveillance",
      "Enseignement du client"
    ],
    pricing: "Le prix varie selon le service demandé",
    accent: "accent-blue"
  },
  {
    id: 2,
    category: "foot-care",
    title: "Soins de pieds",
    description: "Soins complets des pieds incluant ongles incarnés, cors et callosités",
    image: "https://images.pexels.com/photos/5889984/pexels-photo-5889984.jpeg",
    services: [
      "Traitement des ongles incarnés",
      "Élimination des cors et callosités",
      "Soins pour pieds diabétiques",
      "Prévention des complications",
      "Conseils d'hygiène"
    ],
    pricing: "Avec ou sans prescription des frais de 15$ s'appliquent à l'ouverture de dossier\n\n75 $ par heure Chez le client",
    accent: "accent-green"
  },
  {
    id: 3,
    category: "specialized",
    title: "Soins spécialisés",
    description: "Services personnalisés selon vos besoins spécifiques de santé",
    image: "https://images.pexels.com/photos/7722685/pexels-photo-7722685.jpeg",
    services: [
      "Évaluation complète",
      "Plan de soins personnalisé",
      "Suivi à domicile",
      "Soins de sonde urinaire",
      "Soins de stomie", 
      "Injection sous-cutanée ou intra-musculaire",
      "Prise de signes vitaux",
      "Prise de sang à venir"
    ],
    pricing: "Tarifs sur consultation",
    accent: "accent-cream"
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Suzanne Lalonde",
    age: "67 ans",
    location: "Longueuil",
    text: "Salwa est une professionnelle exceptionnelle. Ses soins pour mes plaies diabétiques ont été remarquables. Je me sens en sécurité avec elle.",
    rating: 5,
    service: "Soins de plaies"
  },
  {
    id: 2,
    name: "Robert Tremblay",
    age: "72 ans",
    location: "Brossard",
    text: "Enfin quelqu'un qui comprend mes problèmes de pieds! Salwa est douce, professionnelle et très compétente. Je la recommande vivement.",
    rating: 5,
    service: "Soins de pieds"
  }
];

export const aboutInfo = {
  introduction: "Infirmière diplômée avec plus de 10 années d'expérience dans le domaine de la santé, je me spécialise dans les soins de plaies et les soins de pieds. Ma passion pour aider les autres et mon expertise me permettent d'offrir des soins de qualité supérieure à domicile.",
  
  qualifications: [
    "Certification en soins de plaies avancés",
    "Formation spécialisée en soins de pieds",
    "Membre de l'Ordre des infirmières du Québec"
  ],
  
  approach: "Mon approche est centrée sur la personne. Je crois que chaque patient mérite des soins personnalisés, dans le confort de son foyer. J'accorde une grande importance à l'éducation du patient et à la prévention.",
  
  mission: "Ma mission est de fournir des soins infirmiers de qualité exceptionnelle, dans un environnement chaleureux et professionnel, tout en respectant la dignité et l'autonomie de chaque personne."
};

export const contactInfo = {
  address: "Secteur Longueuil, Québec",
  phone: "819-469-4419",
  email: "salwa.connexion@gmail.com",
  hours: {
    weekdays: "Lundi - Jeudi + Samedi - Dimanche: 16h00 - 21h00",
    friday: "Vendredi: 8h00 - 21h00"
  },
  emergencyHours: "Soins planifiés uniquement",
  serviceArea: "Longueuil, Brossard, Saint-Lambert, Boucherville, St-Hubert, St-Bruno et environs"
};

// Relevant Medical Images Collection - All Unique Images
export const medicalImages = {
  // Wound care specific images
  woundCare: {
    professional: "https://images.unsplash.com/photo-1609840534277-88833ef3ddeb?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1NzZ8MHwxfHNlYXJjaHwyfHxtZWRpY2FsJTIwd291bmQlMjBjYXJlfGVufDB8fHx8MTc1NTE5OTA2N3ww&ixlib=rb-4.1.0&q=85",
    bandaging: "https://images.pexels.com/photos/6129584/pexels-photo-6129584.jpeg",
    treatment: "https://images.pexels.com/photos/7588644/pexels-photo-7588644.jpeg",
    supplies: "https://images.unsplash.com/photo-1663151064065-cb334788f77d"
  },
  
  // Foot care specific images
  footCare: {
    examination: "https://images.pexels.com/photos/6628700/pexels-photo-6628700.jpeg",
    treatment: "https://images.pexels.com/photos/8376285/pexels-photo-8376285.jpeg",
    xray: "https://images.unsplash.com/photo-1690306815613-f839b74af330?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2ODN8MHwxfHNlYXJjaHwzfHxtZWRpY2FsJTIwbnVyc2luZyUyMHN1cHBsaWVzfGVufDB8fHx8MTc1NTE5MjE4N3ww&ixlib=rb-4.1.0&q=85"
  },
  
  // General medical
  medical: {
    injection: "https://images.pexels.com/photos/7469494/pexels-photo-7469494.jpeg",
    equipment: "https://images.unsplash.com/photo-1595464144526-5fb181b74625?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njl8MHwxfHNlYXJjaHwxfHxtZWRpY2FsJTIwZXF1aXBtZW50fGVufDB8fHx8MTc1NTE5OTY2MXww&ixlib=rb-4.1.0&q=85"
  }
};

export const heroImages = {
  background: "https://images.unsplash.com/photo-1612939980779-e8c4579ad7d6?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDJ8MHwxfHNlYXJjaHwxfHxRdWViZWMlMjBzY2VuZXJ5fGVufDB8fHx8MTc1NTE4ODM2OXww&ixlib=rb-4.1.0&q=85",
  nurse: nurseInfo.image,
  equipment: "https://images.unsplash.com/photo-1593086586351-1673fca190cf"
};

// Appointment booking mock data
export const appointmentSlots = [
  { date: "2025-01-20", time: "09:00", available: true },
  { date: "2025-01-20", time: "10:30", available: true },
  { date: "2025-01-20", time: "14:00", available: false },
  { date: "2025-01-20", time: "15:30", available: true },
  { date: "2025-01-21", time: "09:00", available: true },
  { date: "2025-01-21", time: "11:00", available: true },
  { date: "2025-01-21", time: "13:30", available: true },
  { date: "2025-01-21", time: "16:00", available: false }
];

export const serviceTypes = [
  { value: "wound-care", label: "Soins de plaies" },
  { value: "foot-care", label: "Soins de pieds" }
];